import { useDatasourceId } from '@/hooks';
import ViewRef from '@/util/ViewRef';
import { useGetQueryColumnsQuery } from '@/features/addWidgetModal/queryColumnsApi';
import { UUID } from '@/types';

export const useFilterConfiguration = (view: Maybe<ViewRef>) => {
  const datasourceId = useDatasourceId();

  const { data } = useGetQueryColumnsQuery(
    {
      datasourceId,
      seriesId: view?._series as UUID,
    },
    { skip: !view },
  );

  return data;
};
